import {useContext, useEffect, useMemo} from 'react'
import {SectionSearchBarContext} from './SearchBar'
import {useNavigate} from 'react-router-dom'
import {connectService} from 'components/service/connectService'
import {DeviceStatus, DeviceTypes, Modes} from 'utility/utility'
import {Indicator} from 'modules/device/components/Indicator'
import {canCreateDevice} from '../helpers'
import { useSelector } from 'react-redux'

export const Devices = connectService(
  props => {
    const navigate = useNavigate()
    const {skip, total, limit, list, loading, Loader, Placeholder, Paginator, allowActions, business} = props
    const {setPlaceholder} = useContext(SectionSearchBarContext)
    const state = useSelector(state => state.state)

    useEffect(() => {
      setPlaceholder(`Showing ${skip + 1} to ${skip + limit} of ${total}`)
    }, [limit, skip, total])

    const onAdd = () => {
      navigate(`${DeviceTypes.OFFICE}/${Modes.CREATE}`)
    }

    const onEdit = device => {
      navigate(`${DeviceTypes.OFFICE}/${Modes.UPDATE}/${device._id}`)
    }

    const canBusinessCreate = useMemo(() => {
      return canCreateDevice(business?.licenses?.device, total)
    }, [business, total])

    return (
      <div className="table-responsive">
        <table className="vw-table vw-tab-table">
          <thead>
            <tr>
              <th>Device name</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {list.length ? (
              list.map(item => (
                <tr className="data-list" key={item._id}>
                  <td>
                    <Indicator
                      device={item._id}
                      state={state?.[item._id] ? DeviceStatus.Live : DeviceStatus.Offline}
                      style={{display: 'inline-block'}}
                      className="mr-2"
                    />
                    {item.name}
                  </td>
                  <td>
                    {item.allowBrowser && (
                      <>
                        {item.browserOptions?.length} <i className="fa fa-globe"></i>
                      </>
                    )}
                  </td>
                  <td className="text-right">
                    <button className="btn btn-primary" onClick={() => onEdit(item)}>
                      View/Edit
                    </button>
                  </td>
                </tr>
              ))
            ) : loading ? (
              <Loader colSpan="2" />
            ) : (
              <Placeholder placeholder="No Devices" colSpan="2" />
            )}
          </tbody>
        </table>
        {(allowActions || canBusinessCreate) && (
          <div className="vw-group-button">
            <button className="btn btn-add btn-add--lg vw-tab-group-button" onClick={onAdd}>
              <i className="fal fa-plus"></i>
            </button>
          </div>
        )}
        {Paginator({
          className: 'd-flex flex-row-reverse mt-2',
          sm: true
        })}
      </div>
    )
  },
  'device',
  {
    query: {
      type: DeviceTypes.OFFICE,
      $sort: {name: 1}
    },
    paramsAsQueryParams: ['distributor', 'reseller', 'business']
  }
)
